module.exports = __webpack_public_path__ + "img/search-map.fadc1486.svg";